/* eslint-disable */
import React from 'react';

function DetailTabCont3() {
  return (
    <>
      <section className="box cont_box">
        <div className="cont_tit">공지 내용</div>
        <div className="com_board_box">
          1) 평가 기준 <br />
          - 캠페인 기간내 <br />
          (수업수 + 인센티브 + 기여도) - (손실 + c/s) 합산 점수 <br />
          &lt;중단0&gt;과 &lt;인계0&gt;은 집계에서 제외함 <br />
          &lt;중단/인계 1사유가 1건 발생시에만 만회가능 &gt; <br /> <br />
          2) 캠페인 기간 內 누적수업 90회 이상 <br />
          수업한 교사를 1~3위로 선정
          <div className="com_btn_wrap center btn_fixed right">
            <button className="com_btn black xs btn_down_orange">다운로드</button>
          </div>
        </div>
      </section>
      <section className="box cont_box">
        <div className="cont_tit">그룹</div>
        <div className="com_board_box">
          <ul className="group_list">
            <li className="group">
              <div className="com_info">
                <p className="name">1위 그룹</p>
              </div>
              <div className="board_item_table">
                <table className="com_board_list">
                  <colgroup>
                    <col width="110" />
                    <col width="auto" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th className="th_left">포인트 점수</th>
                      <td className="td_left">112P 이상</td>
                    </tr>
                    <tr>
                      <th className="th_left">상금</th>
                      <td className="td_left">
                        500,000
                        <br />
                        중단세이브권 1회
                      </td>
                    </tr>
                    <tr>
                      <th className="th_left">기준</th>
                      <td className="td_left">
                        회원소개,개인전환,과목추가, <br />
                        타임추가등 112P 이상
                      </td>
                    </tr>
                    <tr>
                      <th className="th_left">ex</th>
                      <td className="td_left">
                        7타임 시 112P
                        <br />
                        (ex: 회원소개/개인전환시)
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="cont">홍길동123, 김길동634, 최길동789, 강길동312, 김교사454, 강교사654, 오교사456, 홍길동123, 김길동634, 최길동789, 강길동312, 김교사454, 강교사654, 오교사456, 공교사456홍길동123, 김길동634, 최길동789, 강길동312, 김교사454,강교사654, 오교사456, 홍길동123, 김길동634, 최길동789, 강길동312, 김교사454, 강교사654, 오교사456</div>
              </div>
            </li>
            <li className="group">
              <div className="com_info">
                <p className="name">2위 그룹</p>
              </div>

              <div className="board_item_table">
                <table className="com_board_list">
                  <colgroup>
                    <col width="110" />
                    <col width="auto" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th className="th_left">포인트 점수</th>
                      <td className="td_left">112P 이상</td>
                    </tr>
                    <tr>
                      <th className="th_left">상금</th>
                      <td className="td_left">
                        700,000
                        <br />
                        직급가점: 3점중단세이브권 1회
                      </td>
                    </tr>
                    <tr>
                      <th className="th_left">기준</th>
                      <td className="td_left">
                        회원소개,개인전환,과목추가, <br />
                        타임추가등 112P 이상
                      </td>
                    </tr>
                    <tr>
                      <th className="th_left">ex</th>
                      <td className="td_left">
                        7타임 시 112P
                        <br />
                        (ex: 회원소개/개인전환시)
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="cont">홍길동123, 김길동634, 최길동789, 강길동312, 김교사454, 강교사654, 오교사456, 홍길동123, 김길동634, 최길동789, 강길동312, 김교사454, 강교사654, 오교사456, 공교사456홍길동123, 김길동634, 최길동789, 강길동312, 김교사454,강교사654, 오교사456, 홍길동123, 김길동634, 최길동789, 강길동312, 김교사454, 강교사654, 오교사456</div>
              </div>
            </li>
          </ul>
        </div>
      </section>
      <section className="box cont_box">
        <div className="cont_tit">결과</div>
        <div className="com_board_box">
          <table className="com_board_list">
            <colgroup>
              <col width="60" />
              <col width="105" />
              <col width="105" />
              <col width="auto" />
              <col width="105" />
            </colgroup>
            <thead>
              <tr>
                <th>순위</th>
                <th>포인트 점수</th>
                <th>시상금액</th>
                <th>시상인원</th>
                <th>시상자</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1위</td>
                <td>112P 이상</td>
                <td>1,000,000</td>
                <td>1</td>
                <td>김선생103</td>
              </tr>
              <tr>
                <td>2위</td>
                <td>96P 이상</td>
                <td>850,000</td>
                <td>2</td>
                <td>최선생123, 오선생123</td>
              </tr>
              <tr>
                <td>3위</td>
                <td>80P 이상</td>
                <td>800,000</td>
                <td>3</td>
                <td>강선생231, 최성생456, 오선생789</td>
              </tr>
              <tr>
                <td>4위</td>
                <td></td>
                <td>750,000</td>
                <td>4</td>
                <td>강선생231, 최성생456, 오선생789, 막선생789</td>
              </tr>
              <tr>
                <td>5위</td>
                <td></td>
                <td>700,000</td>
                <td>16</td>
                <td></td>
              </tr>
              <tr>
                <td>6위</td>
                <td></td>
                <td>650,000</td>
                <td>9</td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </>
  );
}

export default DetailTabCont3;
